export const OPEN_SF_CHAT = 'OPEN_SF_CHAT';
export const CLOSE_SF_CHAT = 'CLOSE_SF_CHAT';

export const setSfChatIsOpen = shouldOpen => dispatch => {
    const type = shouldOpen ? OPEN_SF_CHAT : CLOSE_SF_CHAT;
    dispatch({ type });
};
